module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-pl.ddfe63e2098eec1b2ddb.svg";